import { useCallback, useState } from 'react';
import { useFocusEffect } from '@betty/navigation';
import { logError } from '@betty/toolkit/logging';
import { UnverifiedPaymentMethod } from '../state/payment/payment.types';
import PaymentService from '../services/PaymentService/PaymentService';

const useUnverifiedPaymentMethods = () => {
  const [data, setData] = useState<UnverifiedPaymentMethod[]>();

  const fetch = useCallback(async () => {
    try {
      const data = await PaymentService.getUnverifiedPaymentMethods();

      setData(data);
    } catch (error) {
      logError('Unverified payment methods request failure.', error);
    }
  }, []);

  useFocusEffect(
    useCallback(() => {
      fetch();
    }, [fetch]),
  );

  return { data };
};

export default useUnverifiedPaymentMethods;
